<div class="flex flex-row justify-end gap-2 items-center mt-2">
  <button (click)="onCancel()" class="mat-dense" mat-flat-button type="button">
    {{ cancelText | transloco }}
  </button>
  <button
    appLoadingButton
    [loadingState]="loading"
    (click)="onSubmit()"
    class="mat-dense"
    [disabled]="disableSubmit"
    color="primary"
    mat-flat-button
    type="submit"
  >
    {{ submitText | transloco }}
  </button>
</div>
